import { Link } from 'react-router-dom';

export default function CategoryEntry() {
  return (
    <section className="w-full px-4 md:px-16 lg:px-24 -mt-12 md:-mt-16 relative z-20">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-6">
        <Link
          to="/detail/kind-sister-in-law"
          className="group relative overflow-hidden rounded-lg bg-primary-900 p-6 md:p-8 flex items-center justify-between cursor-pointer"
        >
          <div className="relative z-10 max-w-[70%]">
            <span className="inline-flex items-center gap-1.5 text-accent-400 text-xs font-medium mb-3">
              <i className="ri-book-open-line" />
              剧集介绍
            </span>
            <h3 className="font-heading font-bold text-background-50 text-lg md:text-2xl">
              善良的小姨子 · 剧情全解析
            </h3>
            <p className="text-background-100/70 text-sm mt-2 leading-relaxed">
              从人物关系到故事走向，带你读懂这部温暖治愈的家庭情感剧。
            </p>
            <span className="inline-flex items-center gap-1 text-accent-400 text-sm font-medium mt-4 group-hover:gap-2 transition-all">
              查看剧情
              <i className="ri-arrow-right-line" />
            </span>
          </div>
          <i className="ri-movie-2-line absolute -right-3 -bottom-4 text-[120px] text-background-50/10 group-hover:text-background-50/15 transition-colors" />
        </Link>

        <Link
          to="/category"
          className="group relative overflow-hidden rounded-lg bg-accent-500 p-6 md:p-8 flex items-center justify-between cursor-pointer"
        >
          <div className="relative z-10 max-w-[70%]">
            <span className="inline-flex items-center gap-1.5 text-foreground-800 text-xs font-medium mb-3">
              <i className="ri-list-check-2" />
              剧集列表
            </span>
            <h3 className="font-heading font-bold text-foreground-950 text-lg md:text-2xl">
              全部剧集 · 分类浏览
            </h3>
            <p className="text-foreground-800/80 text-sm mt-2 leading-relaxed">
              按更新状态、集数筛选排序，快速找到你想看的那一部。
            </p>
            <span className="inline-flex items-center gap-1 text-foreground-950 text-sm font-medium mt-4 group-hover:gap-2 transition-all">
              浏览全部
              <i className="ri-arrow-right-line" />
            </span>
          </div>
          <i className="ri-grid-fill absolute -right-3 -bottom-4 text-[120px] text-foreground-950/10 group-hover:text-foreground-950/15 transition-colors" />
        </Link>
      </div>
    </section>
  );
}